import { FC } from 'react';

import SupplierListing from 'components/main/Supplier';

const Supplier: FC = () => <SupplierListing />;

export default Supplier;
